import React from "react";
import PropTypes from "prop-types";
import TabNav from "../common/TabNav";
import TabNavItem from "../common/TabNavItem";
import { GetTopNavItems } from "./NavItemHelper";

const TopNav = ({ topNavTabSettings, scope }) => {
	const items = GetTopNavItems(topNavTabSettings, scope);
	return (
		<nav>
			<TabNav>
				{items.map((item, i) => <TabNavItem key={i} display={item.text} iconType={item.iconType} color={item.color}
					to={item.to} disabled={item.disabled} visible={item.visible} />)}
			</TabNav>
		</nav>
	);
};

TopNav.propTypes = {
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string
};

export default TopNav;